// extracted by mini-css-extract-plugin
export default {"bg":"TipsPop_bg__E0Vns","container":"TipsPop_container__MG0f-","tipsbg":"TipsPop_tipsbg__AB2Qj","tipsmsg":"TipsPop_tipsmsg__qkHWV","animate-rotate":"TipsPop_animate-rotate__2FlG1"};